import React, { useEffect, useState } from 'react';
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import { Button, Col, Row, Spinner } from 'reactstrap';
import { TextField, FormLabel, MenuItem, CircularProgress, Box, Typography } from '@material-ui/core';
import CKEditors from "react-ckeditor-component";
import DropzoneUploader from 'components/dropzone';
import Select from '@material-ui/core/Select';
import { FILE_TYPES, NOTIFICATION_CATEGORIES, SUPPORTED_FILE_TYPES } from 'constant/variables';
import { uploadFile } from 'service/cloudinaryService';
import { CLOUDINARY_UPLOAD_PRESET } from 'config';
import { addNotification, getNotification } from 'service/notificationsService';
import { getFileExtension } from 'utils';
import Swal from 'sweetalert2';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import Loader from 'components/loader';
import FileViewerModel from 'components/fileViewer';

export const categories = [
    { name: "Notification", value: NOTIFICATION_CATEGORIES.NOTIFICATION },
    { name: "Offer", value: NOTIFICATION_CATEGORIES.OFFER },
    { name: "Training", value: NOTIFICATION_CATEGORIES.TRAINING },
];

const AddNotifications = (props) => {
    const [category, setCategory] = useState("select");
    const [body, setBody] = useState('');
    const [subject, setSubject] = useState('');
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [fileLink, setFileLink] = useState("");
    const [fileType, setFileType] = useState("");
    const [categoryError, setCategoryError] = useState("");
    
    const history = useHistory();
    const { id } = useParams();
    
    const [fetching, setFetching] = useState(!!id);

    console.log("Add Notification Render", id);

    useEffect(() => {
        if(id) {
            getData();
        }
    }, [id]);

    const getData = () => {
        getNotification(id).then(res => {
            console.log("AddNotification getData", res);
            const resData = res.data || {};
            if(resData.Id) {
                setCategory(resData.Category);
                setSubject(resData.Subject);
                setBody(resData.Body);
                setFileLink(resData.FileLink);
                setFileType(resData.FileType);
            }
        }).catch(error => {
            console.log("AddNotification getData catch", error);
            Swal.fire({
                icon: "error",
                title: error.message || "Something Went Wrong!",
            }).then(() => {
                history.push(`${process.env.PUBLIC_URL}/notifications/add`);
            });
        }).finally(() => {
            setFetching(false);
        })
    }

    const onChange = (evt) => {
        const newContent = evt.editor.getData();
        setBody(newContent);
        setBodyError("");
    }
    const [file, setFile] = useState();
    const [bodyError, setBodyError] = useState("");
    const [fileError, setFileError] = useState("");

    const handleChangeCategory = (event) => {
        setCategory(event.target.value);
    };

    const handleImageChange = (files) => {
        const newImage = files[0];
        if (newImage) {
            setFile(newImage);
            setFileError("");
            console.log("Add handleImageChange", getFileExtension(newImage.name));
        }
    }

    const handleSubjectChange = (event) => {
        setSubject(event.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        // if (!body) {
        //     setBodyError("Please enter description");
        //     return;
        // }
        // if (!file && !fileLink) {
        //     setFileError('Please select file');
        //     return;
        // }
        if(category === 'select') {
            setCategoryError("Please select category");
            return;
        }
        if (file && !getFileType(file.name)) {
            Swal.fire({
                icon: "error",
                title: `Unsupported file type .${getFileExtension(file.name)}`,
                confirmButtonText: "Okay",
            });
            return;
        }
        setLoading(true);

        if(file) {
            upload();
        } else if(fileLink && id) {
            add(fileLink);
        } else {
            add("");
        }
    }

    const upload = () => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                console.log(percentCompleted);
                setProgress(percentCompleted);
            }
        }

        uploadFile(formData, config).then(res => {
            const resData = res.data || {};
            console.log("AddNotification upload", res);
            add(resData.secure_url);
        }).catch((error) => {
            console.log("AddNotification upload catch", error);
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: `File Upload Failed!`,
              });
        });
    }

    const add = (file_link) => {
        const data = {
            category,
            subject,
            body,
            file_type: file ? getFileType(file.name) : "",
            file_link
        }

        if(id) {
            data.id = id;
        }

        addNotification(data).then(res => {
            Swal.fire({
                icon: "success",
                title: `${id ? "Updated" : "Added"} successfully`,
            }).then(() => {
                history.push(`${process.env.PUBLIC_URL}/notifications`);
            });
        }).catch(error => {
            console.log("error", error)
            if(error.errorObj?.status != 401) {
                Swal.fire({
                    icon: "error",
                    title: `Add Failed`,
                  });
            }
           
        }).finally(() => {
            setLoading(false);
        })
    }

    const getFileType = (fileName) => {
        const extension = getFileExtension(fileName);
        let type = "";
        if (SUPPORTED_FILE_TYPES.PDF.includes(extension)) {
            type = FILE_TYPES.PDF;
        } else if (SUPPORTED_FILE_TYPES.EXCEL.includes(extension)) {
            type = FILE_TYPES.EXCEL
        } else if (SUPPORTED_FILE_TYPES.VIDEO.includes(extension)) {
            type = FILE_TYPES.VIDEO
        }
        return type;
    }

    return (
        <>
            <Breadcrumb title={props.t("Add Notification")} />
            <div className="app-wrapper">
                <div className="animated slideInUpTiny animation-duration-3">
                    <Col className="">
                        {!fetching ? <form onSubmit={handleSubmit}>
                            <div className="col-12 mb-4">
                                <Row>
                                    <div className='mb-4 col-6'>
                                        <TextField value={subject} onChange={handleSubjectChange} required id="standard-required" label="Subject" className="col-6" />
                                    </div>
                                    <div className='col-4 mt-3'>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={category}
                                            onChange={handleChangeCategory}
                                            className="col-12"
                                            error={categoryError}
                                        >
                                            <MenuItem value="select">Select Category</MenuItem>
                                            {categories.map(item => (
                                                <MenuItem value={item.value}>{item.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </div>
                                </Row>
                                <FormLabel required>Body</FormLabel>
                                <CKEditors
                                    activeClass={`${bodyError ? 'border border-danger' : null}`}
                                    content={body}
                                    events={{
                                        "change": onChange
                                    }}
                                />
                                <FormLabel className='mt-4' required>Select File</FormLabel>
                                <DropzoneUploader error={fileError} onChange={handleImageChange} />
                                {fileLink && id && !file ? <div>
                                    {/* {fileLink} */}
                                    <FileViewerModel isAdmin={true} subject={""} file_type={fileType} file_link={fileLink} />
                                </div> : null}
                                <div className='my-3 d-flex justify-content-end align-items-center'>
                                {loading ? <Typography variant="caption" component="div" color="textSecondary">Uploading</Typography> : null}
                                    {loading ? <Box position="relative" display="inline-flex" className='mx-2'>
                                        <CircularProgress style={{color: '#0063a4'}} variant="determinate" value={progress} />
                                        <Box
                                            top={0}
                                            left={0}
                                            bottom={0}
                                            right={0}
                                            position="absolute"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                                                progress
                                            )}%`}</Typography>
                                        </Box>
                                    </Box> : null}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        // onClick={handleReset}
                                        type='submit'
                                        style={{ height: 36, width: 80 }}
                                        disabled={loading}
                                        className="align-items-center justify-content-center d-flex"
                                    >
                                        {loading ? <Spinner size="sm" /> : <span>
                                            Add
                                        </span> }
                                    </Button>
                                </div>
                            </div>
                        </form> : <div className='d-flex mt-5 pt-5' style={{height: 200}}><Loader /></div>}
                    </Col>
                </div>
            </div>
        </>
    );
};

export default translate(AddNotifications);
